/**
 * The legal entity that operates denqfabrik.com — the ONE source for every legal surface of
 * this app: Impressum (DE), Imprint (EN), Datenschutz (DE), Privacy (EN) and the footer
 * copyright. Change a value here, never in a page; the pages only read it.
 *
 * Register data verified against the Handelsregister extract (AD) of 2026-09-22: Amtsgericht
 * Hannover, HRB 230751, Geschäftsanschrift Almhorster Straße 6, 30926 Seelze, GF René Nowotny.
 */
export interface LegalEntity {
  name: string;
  street: string;
  postalCode: string;
  city: string;
  managingDirector: string;
  registerCourt: string;
  registerNumber: string;
  /**
   * USt-IdNr. of the GmbH — deliberately UNSET: none is known yet, possibly none exists.
   * § 5 Abs. 1 Nr. 6 DDG requires it only if one exists, so the pages render the line only
   * when this is set. Never put the freelancer's number here: it belongs to a different
   * legal entity.
   */
  vatId?: string;
  phone: string;
  email: string;
}

export const legalEntity: LegalEntity = {
  name: 'Denqfabrik GmbH',
  street: 'Almhorster Str. 6',
  postalCode: '30926',
  city: 'Seelze',
  managingDirector: 'René Nowotny',
  registerCourt: 'Amtsgericht Hannover',
  registerNumber: 'HRB 230751',
  phone: '+49 (0) 157 890 952 76',
  email: 'kontakt@denqfabrik.de',
};
